import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Search, Plus, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useLocale } from "@/contexts/LocaleContext";

export default function MobileBottomNav() {
  const { user } = useAuth();
  const { t } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const handlePublish = (e) => {
    e.preventDefault();
    if (!user) return navigate("/register");
    if (user.role === "agente") return navigate("/dashboard/new");
    // Buscador: encourage upgrading account by taking them to registration for agents
    return navigate("/register");
  };

  const profilePath = !user ? "/login" : user.role === "agente" ? "/dashboard" : "/favorites";
  const isProfileActive = user
    ? (user.role === "agente"
        ? location.pathname.startsWith("/dashboard")
        : location.pathname.startsWith("/favorites"))
    : location.pathname === "/login";

  const isPublishActive = location.pathname.startsWith("/dashboard/new");

  const itemBase =
    "flex-1 flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-[0.14em] transition-colors";
  const activeText = "text-primary font-semibold";
  const idleText = "text-muted-foreground";

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-background/95 backdrop-blur border-t border-border pb-safe"
      data-testid="mobile-bottom-nav"
      aria-label="Menú de navegación"
    >
      <div className="flex items-stretch">
        <NavLink
          to="/properties"
          data-testid="bottom-nav-explore"
          className={({ isActive }) => `${itemBase} ${isActive ? activeText : idleText}`}
        >
          <Search className="h-5 w-5" />
          <span>{t("bottom.explore")}</span>
        </NavLink>

        <button
          type="button"
          onClick={handlePublish}
          data-testid="bottom-nav-publish"
          className={`${itemBase} ${isPublishActive ? activeText : idleText}`}
        >
          <span className="rounded-full bg-primary text-primary-foreground p-2 -mt-6 shadow-lg ring-4 ring-background">
            <Plus className="h-5 w-5" />
          </span>
          <span>{t("bottom.publish")}</span>
        </button>

        <NavLink
          to={profilePath}
          data-testid="bottom-nav-profile"
          className={`${itemBase} ${isProfileActive ? activeText : idleText}`}
        >
          <User className="h-5 w-5" />
          <span>{t("bottom.profile")}</span>
        </NavLink>
      </div>
    </nav>
  );
}
